import { render, staticRenderFns } from "./GenerationPpm.vue?vue&type=template&id=01a97e79"
import script from "./GenerationPpm.vue?vue&type=script&lang=js"
export * from "./GenerationPpm.vue?vue&type=script&lang=js"
import style0 from "./GenerationPpm.vue?vue&type=style&index=0&id=01a97e79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports